import { render, staticRenderFns } from "./MetadataCoapParameterExtractorFields.vue?vue&type=template&id=1d923e8c&"
import script from "./MetadataCoapParameterExtractorFields.vue?vue&type=script&lang=ts&"
export * from "./MetadataCoapParameterExtractorFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports